// Front Office screens a user can be limited to (Users → Front Office Menus).
// Keys are the screen keys App.js uses for the Front Office menu.
export const FO_MENU_GROUPS = [
  { label: 'Reservations', items: [
    { key: 'pms-reservations', label: 'Reservations' },
    { key: 'pms-walkin', label: 'Walk-in Check-in' }
  ] },
  { label: 'Operations', items: [
    { key: 'pms-command-center', label: 'Command Center' },
    { key: 'pms-front-desk-board', label: 'Front Desk Board' },
    { key: 'pms-dashboard', label: 'Dashboard' },
    { key: 'pms-night-audit', label: 'Night Audit' },
    { key: 'pms-group-booking', label: 'Group Booking' }
  ] },
  { label: 'Guests', items: [
    { key: 'pms-guest-master', label: 'Guest Master' },
    { key: 'pms-guest-requests', label: 'Guest Requests' },
    { key: 'pms-guest-feedback', label: 'Guest Feedback' },
    { key: 'pms-police-report', label: 'Police Report' },
    { key: 'pms-google-review', label: 'Google Review' }
  ] },
  { label: 'Rates & Billing', items: [
    { key: 'pms-rate-matrix', label: 'Rate Matrix' },
    { key: 'pms-rate-quotation', label: 'Rate Quotations' },
    { key: 'pms-invoice-register', label: 'Invoices' },
    { key: 'pms-agent-payments', label: 'Agent Payments' },
    { key: 'pms-upsell-products', label: 'Upsell Products' },
    { key: 'pms-upsell-leaderboard', label: 'Upsell Leaderboard' }
  ] },
  { label: 'Inventory & Channels', items: [
    { key: 'pms-room-inventory', label: 'Room Inventory' },
    { key: 'pms-easeroom-cm', label: 'EaseRoom CM' }
  ] },
  { label: 'Reports & Audit', items: [
    { key: 'pms-reports', label: 'Reports' },
    { key: 'pms-gm-reports', label: 'GM Reports' },
    { key: 'pms-door-audit', label: 'Door Audit' },
    { key: 'pms-invoice-amend-audit', label: 'Invoice Amendment Audit' }
  ] },
  { label: 'Setup', items: [
    { key: 'pms-masters', label: 'Masters' }
  ] }
];

export const FO_MENU_KEYS = FO_MENU_GROUPS.flatMap((g) => g.items.map((i) => i.key));

// What a limited user may do on the Reservations screen. Not screens — kept
// apart from FO_MENU_KEYS so they never become a landing screen.
export const FO_RES_STATUS_KEYS = {
  TENTATIVE: 'pms-res-tentative',
  CONFIRMED: 'pms-res-confirmed',
  GUARANTEED: 'pms-res-guaranteed'
};
export const FO_RES_RECENT_KEY = 'pms-res-recent';
export const FO_RESERVATION_GROUP = { label: 'Reservation Screen', items: [
  { key: FO_RES_STATUS_KEYS.TENTATIVE, label: 'Status: Tentative' },
  { key: FO_RES_STATUS_KEYS.CONFIRMED, label: 'Status: Confirmed' },
  { key: FO_RES_STATUS_KEYS.GUARANTEED, label: 'Status: Guaranteed' },
  { key: FO_RES_RECENT_KEY, label: 'Recent Reservations list' }
] };
export const FO_ALL_KEYS = [...FO_MENU_KEYS, ...FO_RESERVATION_GROUP.items.map((i) => i.key)];

// Reservation statuses a user may pick. No list (not limited) = all; a list
// with none of the status ticks = all too, so lists saved before these ticks
// existed keep working.
export const allowedReservationStatuses = (foMenuAccess) => {
  const all = Object.keys(FO_RES_STATUS_KEYS);
  if (!Array.isArray(foMenuAccess)) return all;
  const picked = all.filter((s) => foMenuAccess.includes(FO_RES_STATUS_KEYS[s]));
  return picked.length ? picked : all;
};
